export default __webpack_public_path__ + "static/media/capacitybuilding.89370d89.png";